'use client';

import { TOKEN_EXPIRATION_TIME_MS } from '@/features/auth/constants/tokenTime';
import { invalidateSessionCache } from '@/features/auth/utils/sessionCache';
import logger from '@/utils/logger';
import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';

export const useSessionRefresh = () => {
  const { data: session, update, status } = useSession();
  const timerRef = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    const refreshToken = async () => {
      try {
        await update();
        // 세션 갱신 후 캐시 무효화
        invalidateSessionCache();
      } catch (error) {
        logger.error(error);
      }
    };

    // 로그인 상태일 때만 타이머 등록
    if (status === 'authenticated' && !timerRef.current) {
      logger.info('++ add timer : ', status);
      timerRef.current = setInterval(refreshToken, TOKEN_EXPIRATION_TIME_MS);
    }

    // 로그인 상태가 아니고 타이머가 있을 때 해제
    if (status === 'unauthenticated' && timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = undefined;
      logger.info('++ remove timer : ', status);
    }
  }, [status, session?.user, update]);

  return {
    isAuthenticated: status === 'authenticated',
    session,
  };
};

export default useSessionRefresh;
